import { mix } from "@chorda/core";
export const Select = (props) => {
    return mix({
        tag: 'select',
        defaultItem: Option
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        items: props.options,
        defaultItem: props.optionAs,
        dom: {
            size: props.size,
            defaultValue: props.value
        }
    });
};
export const Option = (props) => {
    return mix({
        tag: 'option'
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        text: props.text,
        dom: {
            value: props.value,
            selected: props.selected
        }
    });
};
